import { useEffect } from "react";

import { atom, useAtom } from "../app-jotai";

import { loadDrawolaLocale } from "../locales";

import { getPreferredLanguage } from "./language-detector";
// DRAWOLA:CUSTOM-START app language
import { saveManualLanguage } from "./languagePreference";
// DRAWOLA:CUSTOM-END

export const appLangCodeAtom = atom(getPreferredLanguage());

// DRAWOLA:CUSTOM-START app language
/**
 * The one action for a visitor's own language choice: shows it and saves it.
 * Upstream cached every language here, also an automatic one, which then
 * looked like a manual choice on the next visit.
 */
export const selectAppLanguageAtom = atom(null, (_get, set, code: string) => {
  set(appLangCodeAtom, code);
  saveManualLanguage(code);
});
// DRAWOLA:CUSTOM-END

export const useAppLangCode = () => {
  const [langCode, setLangCode] = useAtom(appLangCodeAtom);

  // Ordering of overlapping loads is handled inside loadDrawolaLocale (a
  // request token drops stale results), so no caller-side guard is needed.
  useEffect(() => {
    loadDrawolaLocale(langCode);
  }, [langCode]);

  return [langCode, setLangCode] as const;
};
